import TrigrService from "./trigr-service";
import LotameService from "./lotame-service";
import SubscriptionService from "./SubscriptionService";
import * as ConsentService from "app/services/ConsentService";
import AdType from "types/AdType";

class AdditionalCustomParameterService {
    constructor({ playerHtmlChildId }) {
        this._playerHtmlChildId = playerHtmlChildId;
    }

    async fillAdditionalParams(adType, custParams) {
        return this.fetchData(adType).then(results => {
            const [
                triggerResult,
                subscriberStatus,
                { consentParams, lotameResult }
            ] = results;

            if (triggerResult && triggerResult.results && triggerResult.results.length > 0) {
                custParams.tr = triggerResult.results.join(",");
            }

            if (subscriberStatus) {
                custParams.subscriber = subscriberStatus;
            }

            if (lotameResult && lotameResult.length > 0) {
                const lotame = lotameResult.join(",");
                custParams.ksg = lotame;
            }


            if (consentParams) {
                const { gdpr, consentString, usPrivacy } = consentParams;
                Object.assign(custParams, {
                    gdpr,
                    "gdpr_consent": consentString,
                    "us_privacy": usPrivacy
                });
            }
        });
    }

    async fetchData(adType) {
        if (adType !== AdType.PREROLL) {
            return this._fetchServiceData();
        }


        if (!this._prerollFetchDataPromise) {
            this._prerollFetchDataPromise = this._fetchServiceData();
        }

        return this._prerollFetchDataPromise;
    }

    _fetchServiceData() {
        const servicePromises = [
            new TrigrService().getTrigrResults(),
            SubscriptionService.getSubscriberStatus(),
            ConsentService.fetchParams().then(async consentParams => ({
                consentParams,
                lotameResult: consentParams.isPersonalizedAdAllowed &&
                    (await new LotameService({ playerHtmlChildId: this._playerHtmlChildId }).getSegments())
            }))
        ];

        return Promise.all(servicePromises);
    }
}

export default AdditionalCustomParameterService;
